import { render, staticRenderFns } from "./TapApplePayModal.vue?vue&type=template&id=814ba874&"
import script from "./TapApplePayModal.vue?vue&type=script&lang=js&"
export * from "./TapApplePayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports